import { useTasksStore } from '@/stores/tasks'

export default {
  // Форматирование валюты
  download (data) {
    let tasksStore = useTasksStore()
    let statusList = tasksStore.statusList

    // Сопоставление ключей и названий столбцов
    const headers = {
      id: 'ID',
      name: 'Название',
      stage: 'Статус',
      price: 'Цена',
      value: 'Оценка мин.',
      speed: 'Срочная x2',
      guarantee: 'Гарантийный случай',
      dateClosed: 'Дата закрытия',
    };

    // Создаем заголовки CSV на основе сопоставления
    const csvHeaders = Object.keys(headers).map(key => headers[key]).join(',');

    // Преобразуем каждый объект в строку CSV, применяя специальные правила для определенных столбцов
    const csvRows = data.map(row => {
      return Object.keys(headers).map(key => {
        let value = row[key] || ''; // В случае отсутствия значения вставляем пустую строку
        if (key === 'speed' || key === 'guarantee') {
          value = value === 1 ? 'Да' : 'Нет';
        }
        if (key === 'price') {
          value = Math.round(value)
        }
        if (key === 'stage') {
          value = statusList[value]['title']
        }
        if (key === 'dateClosed' && value) {
          const date = new Date(value);
          const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', timeZoneName: 'short' };
          value = new Intl.DateTimeFormat(navigator.language, options).format(date);
        }
        return `"${value.toString().replace(/"/g, '""')}"`; // Обработка кавычек в данных
      }).join(',');
    });

    // Собираем все в один CSV-файл
    const csvFile = [csvHeaders].concat(csvRows).join('\n');

    // Создаем ссылку для загрузки
    const blob = new Blob(["\uFEFF" + csvFile], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'download.csv'; // Название файла
    link.click();

    // Освобождаем URL после скачивания
    URL.revokeObjectURL(url);
  }
}
